<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
}
</script>

<style>
@font-face {
    font-family: "linenazi";
    src: url("./assets/linenazi.ttf"), url("./assets/linenazi.ttf"), url("./assets/linenazi.ttf");
}

@font-face {
    font-family: "title";
    src: url("./assets/title.ttf"), url("./assets/title.ttf"), url("./assets/title.ttf");
}


div::-webkit-scrollbar {
    display: none;
}

section::-webkit-scrollbar {
    display: none;
}

.el-popconfirm__main {
    margin-bottom: 10px;
}

* {
    margin: 0;
    padding: 0;
    flex-shrink: 0;
    font-size: 15px;
    font-family: "linenazi";
}

.contain {
    width: 100vw;
    height: 100vh;
    min-width: 1280px;
    max-width: 1920px;
    max-height: 1080px;
    min-height: 600px;
    font-family: "linenazi";
    margin: 0 auto;
    color: rgb(0, 0, 0);
    background-size: cover;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    position: relative;
    background-color: #F1F6FD;
}

</style>
